import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Tabs, { Tab } from "material-ui-old/Tabs";
import MuiThemeProvider from "material-ui-old/styles/MuiThemeProvider";
import * as dashboard from "../../modules/dashboard";

import { wevoConstants } from "../../modules/wevos";

const { DASHBOARD_CONFIG_ARRAY } = wevoConstants;
const STYLES = {
    /* Tab Text */
    headline: {
        fontSize: "1.8rem",
        fontFamily: "proxima-nova, sans-serif",
        paddingTop: 45,
        height: 90
    },
    /* Tab Text */
    activeHeadline: {
        fontWeight: "bold"
    },

    /* Actual Tab 'button' style */
    button: {
        background: "transparent",
        color: "black",
        padding: 0,
        margin: 0
    },

    /* Bar beneath Tab label */
    inkBar: {
        background: "#59c7fa",
        height: "3px"
    },

    /* Area around Tabs */
    tabTemplate: {
        background: "transparent",
        color: "white",
        width: "auto"
    }
};

class StatusFilters extends PureComponent {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {
        if (this.props.value !== value) {
            this.props.onStatusChange(value);
        }
    }

    render() {
        const tabs = DASHBOARD_CONFIG_ARRAY.map(config => {
            const isActive = this.props.selectedStatus === config.key;
            const tabStyles = Object.assign(
                {},
                STYLES.headline,
                isActive ? STYLES.activeHeadline : null
            );
            return (
                <Tab
                    key={`filter-state@${config.key}`}
                    className="c-Tabs_tab"
                    label={config.label}
                    buttonStyle={STYLES.button}
                    style={tabStyles}
                    value={config.key}
                />
            );
        });
        return (
            <MuiThemeProvider>
                <Tabs
                    className="c-Tabs"
                    value={this.props.selectedStatus}
                    onChange={this.handleChange}
                    inkBarStyle={STYLES.inkBar}
                    style={STYLES.tabTemplate}
                    tabItemContainerStyle={STYLES.tabTemplate}
                >
                    {tabs}
                </Tabs>
            </MuiThemeProvider>
        );
    }
}

function mapStateToProps(state, props) {
    const selectedStatus = dashboard.getSelectedStatus(state, props);
    return {
        selectedStatus
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onStatusChange: status => dispatch(dashboard.selectStatus(status))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StatusFilters);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardStatusFilters.js